import { createSelector } from 'reselect';

const selectLMSassignments = (state: any) => state.lmsAssignments;

export const selectLMSassignmentsCurrentItem = createSelector(
  [selectLMSassignments],
  (lmsAssignments) => lmsAssignments.current
);

export const selectLMSassignmentsListItems = createSelector(
  [selectLMSassignments],
  (lmsAssignments) => lmsAssignments.list
);

export const selectLMScoursesItemById = (itemId: any) =>
  createSelector(selectLMSassignmentsListItems, (list) =>
    list.result.items.find((item: any) => item._id === itemId)
  );

export const selectLMSassignmentsQueryItems = createSelector(
  [selectLMSassignments],
  (lmsAssignments) => lmsAssignments.query
);

export const selectLMSassignmentsCreatedItem = createSelector(
  [selectLMSassignments],
  (lmsAssignments) => lmsAssignments.create
);

export const selectLMSassignmentsUpdatedItem = createSelector(
  [selectLMSassignments],
  (lmsAssignments) => lmsAssignments.update
);

export const selectLMSassignmentsReadItem = createSelector(
  [selectLMSassignments],
  (lmsAssignments) => lmsAssignments.read
);

export const selectLMSassignmentsDeletedItem = createSelector(
  [selectLMSassignments],
  (lmsAssignments) => lmsAssignments.delete
);

export const selectLMSassignmentsSearchedItems = createSelector(
  [selectLMSassignments],
  (lmsAssignments) => lmsAssignments.search
);

export const selectLMSassignmentsItemsCount = createSelector(
  [selectLMSassignments],
  (lmsAssignments) => lmsAssignments.count
);

export const selectLMSassignmentsItemsFilter = createSelector(
  [selectLMSassignments],
  (lmsAssignments) => lmsAssignments.filter
);
